<template lang="pug">
    .case
        main(ref="main" v-if="projects.length")
            app-nav(:class="{black:isScrollingOneScreen}")
            section.caseIntro.scrollme.animateme(data-when='span' data-from='0' data-to='0.55' data-easing="linear" data-opacity='0')
                .swiper-container
                    .swiper-wrapper
                        .swiper-slide(v-for="pr in projects" :style="{backgroundImage: 'url('+$rootPath+'/backend/img/projects/'+pr.img+')'}")
                            .yellowP
                            .text.updateMe(data-updating="title")
                                span(v-html="pr.title")
                            .digital(v-html="pr.hashtag")
                    .swiper-nav
                        .swiper-button-prev
                        .swiper-button-next

            section.aboutTask
                .taskParams.scrollme
                    .container
                        .param.animateme(v-show="projects[activeProjectInd].task" data-when='span' data-from='0.3' data-to='0.1' data-easing="linear" data-opacity='0' data-translateY="100")
                            .title Задача
                            .strip
                            .text(v-html="projects[activeProjectInd].task")
                        .param.animateme(v-show="projects[activeProjectInd].solution" data-when='span' data-from='0.4' data-to='0.2' data-easing="linear" data-opacity='0' data-translateY="100")
                            .title Решение
                            .strip
                            .text(v-html="projects[activeProjectInd].solution")
                        .param.animateme(v-show="projects[activeProjectInd].mechanics" data-when='span' data-from='0.5' data-to='0.3' data-easing="linear" data-opacity='0' data-translateY="100")
                            .title Механика
                            .strip
                            .text(v-html="projects[activeProjectInd].mechanics")

                .slider.scrollme.animateme(data-when='span' data-from='0.3' data-to='0.1' data-easing="linear" data-opacity='0.3' data-translateY="200" data-scale="1.2")
                    .swiper-container
                        .swiper-wrapper
                            .swiper-slide(v-for="slide in projects[activeProjectInd].slides")
                                .sliderContent(:style="{backgroundImage:'url('+$rootPath+'/backend/img/projects/slides/'+slide.img+')'}")

                .taskParams.scrollme
                    .container
                        .param.animateme(v-show="projects[activeProjectInd].results" data-when='enter' data-from='0.3' data-to='0.1' data-easing="linear" data-opacity='0' data-translateY="100")
                            .title Результаты
                            .strip
                            .text(v-html="projects[activeProjectInd].results")
                        .param.animateme(v-show="projects[activeProjectInd].tagline" data-when='enter' data-from='0.5' data-to='0.3' data-easing="linear" data-opacity='0' data-translateY="100")
                            .title Награды
                            .strip
                            .text(v-html="projects[activeProjectInd].tagline")

            section.companies.scrollme
                .container
                    .title.animateme(data-when='enter' data-from='0.2' data-to='0' data-easing="linear" data-opacity='0') Media about the project
                    .slider.animateme(data-when='enter' data-from='0.4' data-to='0.1' data-easing="linear" data-opacity='0' data-translateY="-100")
                        .swiper-container
                            .swiper-wrapper
                                a(:href="md.link" target="_blank").swiper-slide(v-for="md in media"
                                            :style="{backgroundImage: 'url('+$rootPath+'/backend/img/media/'+md.img+')'}")
            app-footer

</template>

<script>
    export default {
        name: "Case",
        data:()=>({
            slidesProjectsSlider: null, // слайдер картинок проекта
            projectsSlider: null,
            projects:[],
            media:[],
            activeProjectInd: 0,
            isMobile: document.documentElement.offsetWidth < 769,
            isScrollingOneScreen:window.pageYOffset > window.outerHeight,
        }),
        async mounted() {
            await this.fetchProjects();
            await this.fetchMedia();
            setTimeout(() => {
                this.initSliders();
            })

            setTimeout(()=>{
                this.$refs['main'].classList.add('loaded');
                window.scrollme();
            }, 400);
            window.addEventListener('scroll',this.updateOneScreen);

        },
        beforeDestroy(){
            window.removeEventListener('scroll',this.updateOneScreen);
        },
        watch:{
            activeProjectInd(){
                setTimeout(()=>{
                    this.slidesProjectsSlider.destroy();
                    this.initImgsSlider();
                })
            }
        },
        methods:{
            updateOneScreen(){
                this.isScrollingOneScreen=window.pageYOffset > window.outerHeight/2;
            },
            async fetchProjects() {
                let data = new FormData;
                data.append('action','fetchProjects');
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (responseData && !responseData.error) {
                    this.projects = responseData.projects.filter(el=>el.status==='1');
                } else {
                    console.log(responseData);
                }
            },
            async fetchMedia() {
                let data = new FormData;
                data.append('action','fetchMedia');
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (responseData && !responseData.error) {
                    this.media = responseData.media;
                    setTimeout(this.initMediaSlider)
                } else {
                    console.log(responseData);
                }
            },
            initSliders() {
                let self = this;
                let initialSlide = 0;
                let id = this.$route.params.id-1;
                if (id!==undefined && this.projects[id]){
                    initialSlide = id;
                }
                this.projectsSlider = new Swiper('.caseIntro .swiper-container', {
                    slidesPerView: 1,
                    initialSlide:initialSlide,
                    loop:true,
                    slideActiveClass: 'active',
                    centeredSlides: true,
                    grabCursor: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    on: {
                        slideChange() {
                            self.activeProjectInd = this.realIndex;
                        }
                    },
                })
                this.initImgsSlider();
            },
            initMediaSlider(){
                let caseCompaniesSwiper = new Swiper ('.companies .swiper-container', {
                    loop: true,
                    slidesPerView: 7,
                    spaceBetween: 50,
                    slideActiveClass: 'active',
                    centeredSlides: true,
                    grabCursor: true,
                    breakpoints: {
                        1600: {
                            slidesPerView: 6,
                        },
                        1450: {
                            slidesPerView: 5.5,
                        },
                        768: {
                            slidesPerView: 2.3,
                        }
                    }
                });
            },
            initImgsSlider(){
                this.slidesProjectsSlider = new Swiper('.aboutTask .swiper-container', {
                    slidesPerView: 1.7,
                    spaceBetween: -80,
                    slideActiveClass: 'active',
                    centeredSlides: true,
                    grabCursor: true,
                    breakpoints: {
                        767: {
                            slidesPerView: 1.27,
                            spaceBetween: 5,
                        }
                    },
                });
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_mixins.scss";
    .case{
        main:not(.loaded){
            .caseIntro{
                .yellowP{
                    transform: scale(1.5);
                    opacity: 0;
                }
                .text{
                    transform: translateY(-30%);
                    opacity: 0;
                }

                .swiper-button-prev{
                    opacity: 0;
                }
                .swiper-button-next{
                    opacity: 0;
                }
                .digital{
                    opacity: 0;
                }
            }


        }
        section.caseIntro{
            height: 36.1vw;
            @include razr1400{
                height: 37.1rem;
            }
            .swiper-container{
                height: 100%;
                .swiper-wrapper{
                    height: 100%;
                    .swiper-slide{
                        position: relative;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background: no-repeat center center /cover;
                        color: #fff;

                        .yellowP{
                            position: absolute;
                            top: 0;
                            left: 0;
                            bottom: 0;
                            right: 0;
                            pointer-events: none;
                            transform-origin: center;
                            background: url(../assets/img/case/caseIntro_bg-yellow.svg) no-repeat 50% center /auto 85%;
                            transition: 1.1s 0.5s;
                            z-index: -1;
                        }
                        .text{
                            margin-top: 1rem;
                            font: 800 to_rem(50px)/to_rem(47px) Geometria;
                            letter-spacing: to_rem(1.66px);
                            text-align: center;
                            transition: .5s .2s;
                        }
                        .digital{
                            position: absolute;
                            bottom: 11%;left: 0;right: 4.6%;
                            font: 300 to_rem(18px)/to_rem(28px) Geometria;
                            text-align: center;
                            transition: .7s .6s;
                        }
                    }
                }
                .swiper-nav{
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 100%;
                    max-width: 78.8rem;
                    height: 100%;
                    margin: 0 auto;
                    z-index: 10;
                    .swiper-button-prev, .swiper-button-next{
                        height: 2.4rem;
                        width: 8rem;
                        top: 56.3%;
                        transition: .3s;
                        &:focus{
                            outline: none;
                        }

                        &:hover{
                            width: 10rem;
                        }
                    }
                    .swiper-button-prev{
                        left: 0;
                        background: url(../assets/img/case/arrowYellow-left-hover.png) no-repeat center left /auto 100%;
                    }
                    .swiper-button-next{
                        background: url(../assets/img/case/arrowYellow-right-hover.png) no-repeat center right /auto 100%;
                        right: 0;
                    }
                }
            }
        }
        section.aboutTask{
            padding-top: 7.6rem;
            background: url(../assets/img/case/caseTask_bg.png) no-repeat center  -9%/51% auto;
            .taskParams{
                .container{
                    display: flex;
                    flex-wrap: wrap;
                    max-width: 1120px;
                }
                .param{
                    width: 50%;
                    opacity: 0;
                    .title{
                        font: 700 to_rem(26px)/to_rem(26px) Geometria;
                        margin-bottom: 1.8rem;
                    }
                    .strip{
                        width: 4rem;
                        height: to_rem(5px);
                        margin-bottom: 2rem;
                        margin-left: -2px;
                        background: #ffc819;
                    }
                    .text{
                        min-height: 8.5rem;
                        font: 400 to_rem(18px)/to_rem(24px) Geometria;
                        span{
                            position: relative;
                            display: block;
                            &:after{
                                content: '';
                                position: absolute;
                                top: 0.6rem;
                                left: -1.8rem;
                                display: block;
                                height: to_rem(4px);
                                width: to_rem(4px);
                                border-radius: 50%;
                                background: #000;
                            }
                        }
                        p{
                            padding-bottom: 1.8rem;

                        }
                    }
                }
            }
            .slider{
                opacity: 0;
                margin: 8% 0 6%;
                transition: .3s linear;
                .swiper-container{
                    overflow: visible;
                    .swiper-wrapper{
                        height: initial;
                        .swiper-slide{
                            transform: scale(0.6);
                            transform-origin: center 35%;
                            transition: .5s;
                            &:not(.active){
                                opacity: 0.5;
                            }
                            &.active{
                                transform: scale(1);
                                box-shadow: 0 27px 56px rgba(0, 0, 0, 0.24);
                            }
                            .sliderContent{
                                padding-top: 56%;
                                background: url(../assets/img/case/photoExample.jpg) no-repeat center center / cover;
                            }
                        }
                    }
                }
            }
        }
        section.companies{
            .container{
                max-width: 100%;
                padding: 0;
            }
            .title{
                margin: 8.7rem 0 3.6rem;
                text-align: center;
                font: 700 to_rem(26px)/to_rem(26px) Geometria;
                color: #585858;
                opacity: 0;
                transition: .3s linear;
            }
            .slider{
                background-color: #f4f4f4;
                padding: 3.7rem 0;
                opacity: 0;
                transition: .3s linear;
                transform: translateY(-100px);

                .swiper-container{
                    .swiper-wrapper{
                        height: initial;
                        .swiper-slide{
                            height: 7.3vw;
                            max-height: 10rem;
                            background: no-repeat center center / contain;
                            cursor: url(./../assets/img/cursor-hover.png) 25 25, pointer;

                        }
                    }
                }
            }
        }

        @include razr768{
            section.caseIntro{
                height: 100vh;
                .swiper-container{
                    .swiper-wrapper{
                        .swiper-slide{
                            .yellowP{
                                background: url(../assets/img/case/caseIntro_bg-yellow-mobile.svg) no-repeat 50% 45% /auto 66vw;
                            }
                            .text{
                                font-size: 13vw;
                                line-height: 0.9;
                                margin-top: -11.5vw;
                            }
                            .digital{
                                bottom: 28.3vh;
                                font-size: 5.75vw;
                                right: initial;
                                left: 16.8vw;
                            }
                        }
                    }
                    .swiper-nav{
                        height: 18vh;
                        top: initial;
                        bottom: 7vh;
                        .swiper-button-prev, .swiper-button-next{
                            height: 8vw;
                            width: 15.2vw;
                            background: url(../assets/img/case/arrowYellow-right-mobile.png) no-repeat center center / contain;
                            &:focus{
                            }
                        }
                        .swiper-button-prev{
                            left: 9vw;
                            transform: scale(-1,1);
                        }
                        .swiper-button-next{
                            right: 9vw;
                        }
                    }
                }
            }
            section.aboutTask{
                padding: 36.4vw 0 7vw;
                .taskParams{
                    padding: 0 8.7vw;
                    .container{
                        padding: 0;
                    }
                    .param{
                        width: 100%;
                        margin-bottom: 13.1vw;
                        .title{
                            font-size: 8.5vw;
                            line-height: 1;
                            margin-bottom: 6vw;
                        }
                        .strip{
                            width: 17vw;
                            height: 1.8vw;
                            margin-left: -0.7vw;
                            margin-bottom: 8vw;
                        }
                        .text{
                            font-size: 5.7vw;
                            line-height: 1.4;

                            p{
                                padding-bottom: 7vw;
                                br{
                                    display: none;
                                }

                            }
                        }
                    }
                }
                .slider{
                    margin: 8vw 0 25vw;
                    .swiper-container{
                        .swiper-wrapper{
                            .swiper-slide{
                                transform: scale(0.85);
                                transform-origin: center 47%;
                                &.active{
                                }
                                .sliderContent{
                                    height: 77.5vw;
                                    padding-top: initial;
                                }
                            }
                        }
                    }
                }
            }
            section.companies{
                .container{
                }
                .title{
                    margin: 3vw 0 17vw;
                    font-size: 6.9vw;
                    line-height: 1;
                }
                .slider{
                    .swiper-container{
                        .swiper-wrapper{
                            .swiper-slide{
                                height: 19vw;
                                max-height: initial;
                            }
                        }
                    }
                }

            }
        }
    }
</style>
